import type { FaireProductEntity } from "../../entity_types/product";

export const p_qmnrgkucxg: FaireProductEntity = {
  token: "p_qmnrgkucxg",
  type: "product",
  name: "Wavy Double Color Diamond Open Rings DPJR1459",
  brandToken: "b_kw6x2ac3kg",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/2a2ee5bf988f8d9f14a73fd82843910754054af96866ee39e57ec75df06d5559.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5ebd3799ad6ed9895209536c1f5d535b9af7f6f63b4fb7086c9fc9e11ba64960.jpeg",
    "https://cdn.faire.com/fastly/49ac25abf5d848b84fcb9909a5da027038f1f0b61cdb0373834c5a6f10471054.jpeg",
    "https://cdn.faire.com/fastly/01bedcdba44df588ae555eabb44c9b5b55ee0b2d3a7653c55b1403bd312d5ebc.jpeg",
    "https://cdn.faire.com/fastly/f9489fa66670511e844449c0fc96eb6e96f9eaafa82f7f38a7db6fd3611ac4f7.jpeg",
  ],
  priceDollars: 8.32,
  description:
    "Feature:\n * Simple \n * Hellow \n * Open \n * Double Color\n * Adjustable\n\n Weigh:\n * 10g\n\n Material:\n * Stainless\n\n Package:\n * Package include 1 * ring.\n\n Note: See picture labels (size and weight are hand-measured there will be a small error, specific in kind shall prevail, please note the size before purchase) ",
  tags: [],
  msrpDollars: 16.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:20.954Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
